document.addEventListener('DOMContentLoaded', () => {
  const links = document.querySelectorAll('.modal_link');
  const modals = document.querySelectorAll('.modal-product');
  const openDeliveryModal = document.querySelector('.product__info-unit-price a');
  const deliveryModal = document.querySelector('#versand');
  const deliveryClose = document.querySelector('#versand .modal-product__close');
  const deliveryBtn = document.querySelector('#versand .modal-product__link');

  links.forEach((link) => {
    link.addEventListener('click', () => {
      const dataNumber = link.dataset.number;
      modals.forEach((modal) => {
        if (modal.dataset.number === dataNumber) {
          modal.classList.remove('hidden');
          const close = modal.querySelector('.modal-product__close');
          const modalButton = modal.querySelector('.modal-product__link');
          if (modalButton !== null) {
            modalButton.addEventListener('click', () => {
              modal.classList.add('hidden');
            });
          }
          close.addEventListener('click', () => {
            modal.classList.add('hidden');
          });
        }
      });
    });
  });

  if (openDeliveryModal !== null) {
    openDeliveryModal.addEventListener('click', (event) => {
      event.preventDefault();
      if (deliveryModal !== null) {
        deliveryModal.classList.remove('hidden');
      }
    });
  }

  if (deliveryClose !== null) {
    deliveryClose.addEventListener('click', () => {
      if (deliveryModal !== null) {
        deliveryModal.classList.add('hidden');
      }
    });
  }

  if (deliveryBtn !== null) {
    deliveryBtn.addEventListener('click', () => {
      deliveryModal.classList.add('hidden');
    });
  }
});
